import { Alert, Stack } from '@mui/material';
import { ColDef } from 'ag-grid-community';
import { FC } from 'react';
import Heading from 'src/components/atoms/Heading/Heading';
import { MixedCurrencyAlert } from 'src/components/molecules/MixedCurrencyAlert';
import { MonthSelector } from 'src/components/molecules/MonthSelector/MonthSelector';
import { DetailsContainer } from 'src/components/styled/DetailsContainer';
import { TableWrapper } from 'src/components/styled/TableWrapper';
import { useActiveMonth } from 'src/hooks/useActiveMonth';
import { DataTable, DataTableProps } from '../DataTable/DataTable';

interface DetailsTableProps extends Omit<DataTableProps, 'rows'> {
    title: string;
    rows: Map<string, DataTableProps['rows']> | undefined;
    wrapperClass?: string;
    message?: string;
    monthColumns: ColDef[];
}

const DetailsTable: FC<DetailsTableProps> = ({
    title,
    message,
    monthColumns,
    rows,
    wrapperClass = '',
    ...datatableProps
}) => {
    const [month] = useActiveMonth();

    const currentRows = rows?.get(month);

    return (
        <DetailsContainer data-testid="details-table">
            <Stack
                sx={{
                    gap: 2,
                }}
            >
                <Heading>{title}</Heading>
                {message && (
                    <Alert severity="info" sx={{ alignItems: 'center' }}>
                        {message}
                    </Alert>
                )}
                <MixedCurrencyAlert />
                <MonthSelector months={monthColumns} />
            </Stack>
            <TableWrapper className={`ag-theme-alpine-custom-compact ag-sum ${wrapperClass}`}>
                <DataTable autoSizeToFit {...datatableProps} rows={currentRows} />
            </TableWrapper>
        </DetailsContainer>
    );
};

export default DetailsTable;
